import styled from 'styled-components';

export interface ITitleCategory {
  paddingLeft?: number;
  paddingRight?: number;
}

export const TitleCategory = styled.span<ITitleCategory>`
  justify-content: center;
  font-size: 1em;
  font-weight: 300;
  margin-top: 8px;
  margin-bottom: 8px;
  background-color: #ffffff;

  padding-top: 22px;
  padding-bottom: 22px;
  padding-right: ${(p) => (p.paddingRight ? `${p.paddingRight}px` : '0px')};
  padding-left: ${(p) => (p.paddingLeft ? `${p.paddingLeft}px` : '0px')};
`;

export const IconCard = styled.img`
  height: 25px;
`;

export const ImgDocument = styled.img`
  height: 80px;
  margin-right: 16px;
`;

export const TitleFileChoose = styled.span`
  text-align: left;
  font-size: 1em;
  font-weight: 400;
  padding-top: 12px;
  padding-bottom: 12px;
  margin-top: 8px;
  margin-bottom: 8px;
  margin-right: 8px;
`;

export const TitleFileChooseSmall = styled.span`
  justify-content: left;
  font-size: 0.8em;
  font-weight: 300;
  padding-top: 12px;
  padding-bottom: 12px;
  margin-top: 8px;
  margin-bottom: 8px;
  margin-right: 16px;
`;

export const TitleAbbr = styled.abbr`
  color: red;
`;

export const TitleAbbrFooter = styled.span`
  color: red;
  font-weight: 600;
`;

export const BoxCard = styled.div`
  width: 100%;
  padding: 24px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 10px 26px rgb(0 0 0 / 5%);
  margin-bottom: 24px;
`;
